import { render, staticRenderFns } from "./OptionalStudent.vue?vue&type=template&id=3136c05e"
import script from "./OptionalStudent.vue?vue&type=script&lang=js"
export * from "./OptionalStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports